import * as React from 'react'
import Loadable from 'react-loadable'
import { withOutsideClick } from '../withoutsideclick'
import { reloadStyles } from '../../lib/realod-styles'

// only bundels css
import 'local-emoji-picker/dist/main.css'
import { withEscapeHandler } from '../with-escape-handler'

export const LoadableEmojiPicker = Loadable({
  loader: () => import(/* webpackChunkName: "emoji-picker" */'local-emoji-picker').then((c) => {
    reloadStyles()
    return c
  }),
  render(loaded, props) {
    const Component = loaded['LocalEmojiPicker']
    const EnhancedComponent = withOutsideClick(withEscapeHandler(Component))
    return <EnhancedComponent { ...props } />
  },
  loading: () => null,
  delay: 300
})
